import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import Particle from "../Particle";
import VerticalNavBar from "../VerticalNavBar";
import { format } from "date-fns";
import API from "../../utils/api";
import MCQ from "./Test/McqComponent";
import QuestionReveal from "./Test/Question";
import FillInBlank from "./Test/FillBlank";
import Matching from "./Test/Matching";
import CaseStudy from "./Test/CaseStudy";
import ScenarioDialogue from "./Test/Dialouge";
import CodingProblem from "./Test/ProgramingQ";
import TrueFalseQuestion from "./Test/TrueOrFalse";

// const caseStudyData = {
//   scenario:
//     "Your team is tasked with building a recommendation system for an e-commerce platform. Outline the steps you would take to build this system.",
//   approach:
//     "I would start with data collection, then perform data preprocessing, followed by selecting an algorithm like collaborative filtering. I would then train the model, validate it using a test dataset, and deploy it with regular monitoring and updates.",
// };
// const scenario = {
//   dialogue: [
//     {
//       speaker: "interviewer",
//       text: "Imagine you're working on a machine learning model that is consistently underfitting. What steps would you take to improve its performance?",
//     },
//     {
//       speaker: "interviewee",
//       text: "I would start by increasing the complexity of the model, such as adding more layers or nodes in a neural network. Additionally, I would check for data quality issues and consider feature engineering to better represent the underlying patterns.",
//     },
//     {
//       speaker: "interviewee",
//       text: "I would start by increasing the complexity of the model, such as adding more layers or nodes in a neural network. Additionally, I would check for data quality issues and consider feature engineering to better represent the underlying patterns.",
//     },
//     {
//       speaker: "interviewee",
//       text: "I would start by increasing the complexity of the model, such as adding more layers or nodes in a neural network. Additionally, I would check for data quality issues and consider feature engineering to better represent the underlying patterns.",
//     },
//   ],
// };
// const codingTask = {
//   problem:
//     "Write a Python function to calculate the accuracy of a classification model given the true labels and predicted labels.",
//   expectedSolution: `def calculate_accuracy(true_labels, predicted_labels):\n  return sum(true_labels == predicted_labels) / len(true_labels)`,
//   explanation:
//     "The accuracy is calculated as the ratio of correctly predicted labels to the total number of labels.",
// };
// const trueFalseTask = {
//   statement:
//     "In a convolutional neural network (CNN), the pooling layer reduces the dimensionality of the feature maps.",
//   correctAnswer: "True",
//   explanation:
//     "Pooling layers downsample the feature maps, reducing their spatial dimensions while retaining important features.",
// };
function Test(props) {
  props.setLearning(true);
  const [test, setTest] = useState({
    questions: [],
    description: "",
    date: new Date(),
  });
  // const [change, setChange] = useState(0);
  useEffect(() => {
    // Load initial data on component mount
    API.get("/api/learning/getTest")
      .then((res) => res.data)
      .then((response) => {
        if (response.success) {
          setTest(response.data);
          console.log(response.data);
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the initial data!", error);
      });
  }, []);
  return (
    <>
      <Container fluid className="project-section">
        <Particle />
        <Col>
          <Row>
            <VerticalNavBar
              setIsAuthenticated={props.setIsAuthenticated}
              setLearning={props.setLearning}
            />
          </Row>
        </Col>
        <Container>
          <div className="App">
            {test.description ? (
              <h3>
                Test Id: {test.id}{" "}
                {format(test.date, "EEE, do MMM yyyy: h:mma")}
              </h3>
            ) : (
              <h3>No Tests Available</h3>
            )}
            {test.questions.map((question, index) => {
              switch (question.type) {
                case "mcq":
                  return (
                    <MCQ
                      key={index}
                      index={index + 1}
                      question={question.question}
                      options={question.options}
                      correctOption={question.correct_option}
                      explanation={question.explanation}
                    />
                  );
                case "qa":
                  return (
                    <QuestionReveal
                      key={index}
                      index={index + 1}
                      question={question.question}
                      answer={question.explanation}
                    />
                  );
                case "fill_in_blank":
                  return (
                    <FillInBlank
                      key={index}
                      index={index + 1}
                      sentence={question.sentence}
                      correctAnswer={question.correct_answer}
                      explanation={question.explanation}
                    />
                  );
                case "case_study":
                  return (
                    <CaseStudy
                      key={index}
                      index={index + 1}
                      scenario={question.scenario}
                      approach={question.approach}
                    />
                  );
                case "matching":
                  return (
                    <Matching
                      key={index}
                      index={index + 1}
                      instructions={question.instructions}
                      leftColumn={question.left_column}
                      rightColumn={question.right_column}
                      correctMatches={question.correct_matches}
                    />
                  );
                case "scenario":
                  return (
                    <ScenarioDialogue
                      key={index}
                      index={index + 1}
                      dialogue={question.dialogue}
                    />
                  );
                case "coding":
                  return (
                    <CodingProblem
                      key={index}
                      index={index + 1}
                      problem={question.problem}
                      expectedSolution={question.expected_solution}
                      explanation={question.explanation}
                    />
                  );
                case "true_false":
                  return (
                    <TrueFalseQuestion
                      key={index}
                      index={index + 1}
                      statement={question.statement}
                      correctAnswer={question.correct_answer}
                      explanation={question.explanation}
                    />
                  );
                default:
                  return null;
              }
            })}
          </div>
          <div>
            {test.description && (
              <Card className="mcq-card">
                <Card.Body style={{ backgroundColor: "#934cce5e" }}>
                  <h5>{test.description}</h5>
                  <Button
                    className="primary"
                    onClick={async (e) => {
                      e.preventDefault();
                      var ans = prompt("Enter Code: ");
                      if (ans === "9949") {
                        alert("Come Here Next Time, Your Test is Ready!");
                        try {
                          await API.post("/api/learning/completeTest", {
                            id: test.id,
                          });
                        } catch (err) {
                          alert("Error in server");
                        }
                      } else {
                        alert("It's Wrong, Server is Crashing 3, 2, 1 . . .");
                      }
                    }}
                  >
                    Complete Test
                  </Button>
                </Card.Body>
              </Card>
            )}
          </div>
        </Container>
      </Container>
    </>
  );
}

export default Test;
